/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AttachmentFileResponse {
  name: string;
  /** @format int32 */
  size: number;
  thumbnail?: string | null;
}

export interface AttachmentResponse {
  created_by: User;
  file?: AttachmentFileResponse | null;
  id: string;
  respondent_group: string;
  role: CreatedByRole;
  ticket_id: string;
  /** @format date-time */
  uploaded_at: string;
}

export interface AttachmentsResponse {
  data: Array<AttachmentResponse>;
}

export interface CatalogAreaResponse {
  departments: Array<CatalogDepartmentResponse>;
  description?: string | null;
  /** @example "business_continuity_and_safety" */
  key: string;
  /** @example "Business Continuity & Safety" */
  title: string;
}

export interface CatalogCategoryResponse {
  canEscalate: boolean;
  description: string;
  fields: Array<CatalogFieldReferenceResponse>;
  isFeedback?: boolean | null;
  /** @example "incident_line" */
  key: string;
  nudge?: CatalogNudgeResponse | null;
  supportChannel: CatalogSupportChannelResponse;
  /** @example "Incident Line" */
  title: string;
}

export interface CatalogDepartmentResponse {
  canEscalate?: boolean | null;
  categories: Array<CatalogCategoryResponse>;
  description?: string | null;
  fields: Array<CatalogFieldReferenceResponse>;
  isFeedback?: boolean | null;
  /** @example "business_continuity" */
  key: string;
  nudge?: CatalogNudgeResponse | null;
  supportChannel?: CatalogSupportChannelResponse | null;
  /** @example "Business Continuity" */
  title: string;
}

export interface CatalogFieldDefinitionResponse {
  /**
   * Allowed values: text, textarea, select, checkbox, radio
   * @example "text"
   */
  inputType?: string | null;
  isMulti: boolean;
  isRequired: boolean;
  /** @example "Order Reference" */
  label: string;
  options: Array<string>;
  placeholder?: string | null;
  /** @example "Order Reference" */
  providerKey: string;
  /**
   * Allowed values: number, string, date, boolean
   * @example "string"
   */
  type: string;
  useHelixField: boolean;
  validation?: CatalogFieldValidationResponse | null;
}

export interface CatalogFieldReferenceResponse {
  isRequired?: boolean | null;
  /** @example "description" */
  key: string;
  label?: string | null;
  options?: Array<string> | null;
  placeholder?: string | null;
}

export interface CatalogFieldValidationResponse {
  /** @format int32 */
  maxLength?: number | null;
  /** @format int32 */
  minLength?: number | null;
}

export interface CatalogNudgeResponse {
  isRequired: boolean;
  text: string;
  title?: string | null;
}

/** Typed representation of the current Help Hub catalog */
export interface CatalogResponse {
  areas: Array<CatalogAreaResponse>;
  fields: Record<string, CatalogFieldDefinitionResponse>;
  /** @example "1" */
  version: string;
}

export interface CatalogSupportChannelResponse {
  email?: string | null;
  phoneNumber?: string | null;
  serviceName?: string | null;
  /**
   * Allowed values: help_hub, phone, email, external_service
   * @example "help_hub"
   */
  type: string;
  url?: string | null;
}

export interface CommentResponse {
  attachments: Array<AttachmentResponse>;
  created_by: User;
  id: string;
  respondent_group: string;
  role: CreatedByRole;
  /** @format date-time */
  submit_date: string;
  text: string;
  type: string;
  view_access?: string | null;
}

export interface CommentsResponse {
  data: Array<CommentResponse>;
}

export interface CreateAttachmentParams {
  /** The ticket ID */
  ticketId: string;
}

export interface CreateCommentParams {
  /** The ticket ID */
  ticketId: string;
}

/** Request to create a support ticket using the current catalog */
export interface CreateTicketRequest {
  /** Area selected in the catalog */
  area: string;
  /**
   * Version of the current catalog used to validate the request
   * @example "1"
   */
  catalog_version?: string | null;
  /** Category selected within the chosen department. Required only when the selected department contains categories. */
  category?: string | null;
  custom_fields?: Record<string, CustomFieldDto> | null;
  /** Department selected within the chosen area */
  department: string;
  /**
   * @minLength 20 description must be at least 20 characters
   * @maxLength 2000 description must be at most 2000 characters
   */
  description: string;
  escalated?: boolean | null;
  /**
   * When true, the ticket is created as a resolved feedback entry instead of a standard support ticket. Optional; defaults to false when omitted.
   * @example false
   */
  is_feedback?: boolean | null;
  /**
   * Store linked to the support ticket
   * @format int64
   */
  store_id: number;
  /**
   * @minLength 1 subject must be at least 1 character
   * @maxLength 200 subject must be at most 200 characters
   */
  subject: string;
}

export enum CreatedByRole {
  USER = 'USER',
  SYSTEM = 'SYSTEM',
}

/** A custom field value: string, string[], number, number[], boolean, or date (yyyy-MM-dd) */
export type CustomFieldDto =
  | string
  | Array<string>
  | number
  | Array<number>
  | boolean;

export interface DownloadAttachmentParams {
  /** The attachment ID */
  attachmentId: string;
  /** The ticket ID */
  ticketId: string;
}

export interface GetAttachmentsParams {
  /** The ticket ID */
  ticketId: string;
}

export interface GetCommentsParams {
  /** The ticket ID */
  ticketId: string;
}

export interface GetTicketParams {
  /**
   * Unique identifier of the ticket (format: alphanumeric string)
   * @example "INC000004368701"
   */
  ticketId: string;
}

export interface ListTicketsParams {
  area?: string | null;
  category?: string | null;
  department?: string | null;
  /**
   * @format int32
   * @min 1 page must be >= 1
   * @default 1
   */
  page?: number;
  /**
   * @format int32
   * @min 1 perPage must be >= 1
   * @max 30 perPage must be <= 30
   * @default 10
   */
  per_page?: number;
  /**
   * Optional reporter filter. The only supported value is 'currentuser'. Value matching is case-insensitive. Blank behaves as omitted.
   * @example "currentuser"
   */
  reporter?: ReporterEnum | null;
  search?: string | null;
  sort_by?: TicketSortField | null;
  sort_order?: SortOrder | null;
  status?: TicketStatus | null;
  /**
   * Store ID to filter tickets (required for performance)
   * @format int64
   */
  store_id: number;
}

/**
 * Optional reporter filter. The only supported value is 'currentuser'. Value matching is case-insensitive. Blank behaves as omitted.
 * @example "currentuser"
 */
export enum ListTicketsParams1ReporterEnum {
  Currentuser = 'currentuser',
}

/**
 * Optional reporter filter. The only supported value is 'currentuser'. Value matching is case-insensitive. Blank behaves as omitted.
 * @example "currentuser"
 */
export enum ReporterEnum {
  Currentuser = 'currentuser',
}

export interface SlaResponse {
  /** @format date-time */
  due_date: string;
  expired: boolean;
  id: string;
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export interface TicketListMeta {
  /** @format int32 */
  total: number;
}

export interface TicketListResponse {
  data: Array<TicketResponse>;
  meta: TicketListMeta;
}

export interface TicketResponse {
  area?: string | null;
  category?: string | null;
  /** @format date-time */
  created_at: string;
  created_by: User;
  custom_fields: Record<string, CustomFieldDto>;
  department?: string | null;
  description?: string | null;
  escalated?: boolean | null;
  id: string;
  is_feedback: boolean;
  resolution_note?: string | null;
  slas: Array<SlaResponse>;
  status: TicketStatus;
  store_id?: string | null;
  subject: string;
}

export enum TicketSortField {
  CREATED_AT = 'CREATED_AT',
}

export enum TicketStatus {
  ASSIGNED = 'ASSIGNED',
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  RESOLVED = 'RESOLVED',
  CLOSED = 'CLOSED',
  CANCELLED = 'CANCELLED',
}

export type Unit = object;

export interface User {
  fullname?: string | null;
  id: string;
}
